var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('link',{attrs:{"rel":"import","href":"/codebase/input-elements/input-diagram/emf-report-imports.html"}})])
}]

export { render, staticRenderFns }